import { useMemo } from 'react';
import { useSupervisorInsightContext } from '../Notes/SupervisorInsightContextProvider';

export type useGetSearchLabelsProp = {
  labelId: string;
  idValues: string[];
};

export const useGetSearchLabels = (): useGetSearchLabelsProp[] => {
  const { searchCriteriaInsights } = useSupervisorInsightContext();
  const labelValues = useMemo(() => {
    return Object.values(searchCriteriaInsights.criterions)
      .filter((x) => x.length > 0)
      .map((i: any) => {
        const idValues = i.map((s: any) => {
          return s.id;
        });

        return {
          labelId: i[0].labelId,
          idValues: idValues
        };
      });
  }, [searchCriteriaInsights.criterions]);
  return labelValues;
};
